import { render, staticRenderFns } from "./ComGraficaBrent.vue?vue&type=template&id=741cddab"
import script from "./ComGraficaBrent.vue?vue&type=script&lang=js"
export * from "./ComGraficaBrent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports